import React, { Dispatch, useCallback } from 'react';
import { Badge, IconButton, SxProps } from '@mui/material';
import { vars } from '../../../Theme';
import { IAppReduxStore } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '@mdi/react';
import { mdiFilterOutline } from '@mdi/js';
import { setShowFilter } from '../../../redux/user/sliceUserSettings';

const iconButtonSx: SxProps = {
    width: '34px',
    height: '34px',
    borderRadius: '5px',
    minWidth: '34px',
    padding: '0',
    border: `1px solid ${vars.lightGray}`,
    '&:hover': {
        backgroundColor: vars.fillGray,
    },
};

export default () => {
    const dispatch: Dispatch<unknown> = useDispatch();

    const { showFilter, hasFilteredItems } = useSelector(
        (store: IAppReduxStore) => store.userSettings,
    );

    /**
     * Toggles the visibility of the data grid's filter control.
     */
    const toggleShowFilter = useCallback(() => {
        dispatch(setShowFilter(!showFilter));
    }, [showFilter]);

    return (
        <IconButton sx={iconButtonSx} onClick={toggleShowFilter}>
            <Badge
                sx={{
                    '& .MuiBadge-badge': { backgroundColor: `${vars.brandGreen}` },
                }}
                invisible={!hasFilteredItems}
                variant='dot'
            >
                <Icon
                    path={mdiFilterOutline}
                    size={1}
                    color={hasFilteredItems ? vars.brandGreen : vars.font}
                />
            </Badge>
        </IconButton>
    );
};
